import moment from "moment";
import { Moment } from "moment";
import { EFeeCode, EFeeFor, EFeeFrequency, EFeePosition, EFeeStatus, EFeeType } from "../types/masterFee.type";
import { formatDate } from "./format";
import { priceFormat } from "./priceFormat";

export const renderFeeFrequency = (frequency?: EFeeFrequency) => {
	switch (frequency) {
		case EFeeFrequency.ONE_TIME:
			return "One Time";

		case EFeeFrequency.PER_TRANSACTION:
			return "Transaction";

		case EFeeFrequency.MONTHLY:
			return "Monthly";

		case EFeeFrequency.QUARTERLY:
			return "Quarterly";

		case EFeeFrequency.PER_SEMESTER:
			return "Semester";

		case EFeeFrequency.EVERY_9_MONTHS:
			return "Every 9 Months";

		case EFeeFrequency.YEARLY:
			return "Yearly";
	}
};

export const renderFeeType = (feeType?: EFeeType) => {
	switch (feeType) {
		case EFeeType.AMOUNT:
			return "Nominal";

		case EFeeType.PERCENTAGE:
			return "Percentage";
	}
};
export const renderFeePosition = (feePosition?: EFeePosition) => {
	switch (feePosition) {
		case EFeePosition.TOP:
			return "Top";

		case EFeePosition.BOTTOM:
			return "Bottom";
	}
};

export const renderFeeFor = (feeFor?: EFeeFor) => {
	switch (feeFor) {
		case EFeeFor.OFFICE:
			return "Office";

		case EFeeFor.AGENT:
			return "Agent";
	}
};

export const renderFeeStatus = (feeStatus?: EFeeStatus) => {
	switch (feeStatus) {
		case EFeeStatus.PUBLISH:
			return "Published";

		case EFeeStatus.UNPUBLISH:
			return "Unpublish";
	}
};
export const convertReadableFeeValue = (type?: EFeeType, value?: number, justNumber?: boolean) => {
	if (type === EFeeType.PERCENTAGE) {
		if (!value) {
			return justNumber ? "0" : "0%";
		}
		return +((value ?? 0) * 100).toFixed(2) + (justNumber ? "" : "%");
	} else {
		return priceFormat(value);
	}
};
export const renderFeeDateRange = (startAt?: Date, endAt?: Date) => {
	if (!startAt && !endAt) {
		return "Forever";
	}
	if (startAt && !endAt) {
		return formatDate(startAt) + " - Forever";
	}
	if (!startAt && endAt) {
		return "Not Set - " + formatDate(endAt);
	}
	if (startAt && endAt) {
		return formatDate(startAt) + " - " + formatDate(endAt);
	}
};
export const generateNextFeeCharged = (startAt: Moment, frequency: EFeeFrequency) => {
	var nextChargeAt: null | Moment = moment(startAt);
	switch (frequency) {
		case EFeeFrequency.ONE_TIME:
			nextChargeAt = null;
			break;

		case EFeeFrequency.PER_TRANSACTION:
			nextChargeAt = null;
			break;

		case EFeeFrequency.MONTHLY:
			nextChargeAt.add(1, "month");
			break;

		case EFeeFrequency.QUARTERLY:
			nextChargeAt.add(3, "month");
			break;

		case EFeeFrequency.PER_SEMESTER:
			nextChargeAt.add(6, "month");
			break;

		case EFeeFrequency.EVERY_9_MONTHS:
			nextChargeAt.add(9, "month");
			break;

		case EFeeFrequency.YEARLY:
			nextChargeAt.add(1, "year");
			break;

		default:
			throw new Error("FEE FREQUENCY INVALID: " + frequency);
	}
	return nextChargeAt;
};

export const renderDefaultFeeValue = (feeCode: string) => {
	let value = 0;
	switch (feeCode) {
		case EFeeCode.ssdf:
			value = 0.08;
			break;

		case EFeeCode.royalty:
			value = 0.01;
			break;

		case EFeeCode.agent_development_fee:
			value = 0.0999;
			break;

		case EFeeCode.agent_development_fee_pkp:
			value = 0.0999;
			break;

		default:
			throw new Error("FEE CODE INVALID: " + feeCode);
	}
	return value;
};

export const sortByFeeCode = (data: any[]) => {
	return data.sort((a, b) => {
		if (a.masterFee?.feeCode! === null) return 1;
		if (b.masterFee?.feeCode! === null) return -1;
		if (a.masterFee?.feeCode! < b.masterFee?.feeCode!) return -1;
		if (a.masterFee?.feeCode! > b.masterFee?.feeCode!) return 1;
		return 0;
	});
};
